import * as React from 'react';
import {NUMBER_INPUT_VARIANTS, STEP_DIRECTION_LABEL} from '../_constants';
import type {
  ButtonPosition,
  NumberInputVariants,
  StepDirection,
} from '../_types';
import {NumberInputButtonView} from './NumberInputButton.styles';

interface NumberInputButtonProps {
  isDisabled?: boolean;
  Icon: React.ComponentType<Record<string, unknown>> | null;
  iconProps?: Record<string, unknown>;
  isMin?: boolean;
  isMax?: boolean;
  onClick: (direction: StepDirection, isSkip: boolean) => void;
  position?: ButtonPosition;
  stepDirection: StepDirection;
  inputVariant?: NumberInputVariants;
}

export const NumberInputButton = ({
  isDisabled = false,
  Icon,
  iconProps,
  isMax = false,
  isMin = false,
  onClick,
  position,
  stepDirection,
  inputVariant = NUMBER_INPUT_VARIANTS.DEFAULT,
}: NumberInputButtonProps) => {
  const buttonDisabled = React.useMemo(
    () => isDisabled || isMax || isMin,
    [isDisabled, isMax, isMin]
  );

  const handleStepButtonClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      onClick(stepDirection, event.shiftKey);
    },
    [onClick, stepDirection]
  );

  return (
    <NumberInputButtonView
      aria-disabled={buttonDisabled}
      aria-label={STEP_DIRECTION_LABEL[stepDirection]}
      data-role="number-input-button"
      disabled={buttonDisabled}
      inputVariant={inputVariant}
      isMax={isMax}
      isMin={isMin}
      onClick={handleStepButtonClick}
      position={position}
      tabIndex={-1}
    >
      {Icon && <Icon {...iconProps} />}
    </NumberInputButtonView>
  );
};
